import { useUser } from "..";

export const isStaffRole = () => useUser().user?.isStaff;
